import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { updateUserData } from "../../../store/actions/new/userUpdateAction";
import { CountryDropdown } from "react-country-region-selector";

const PersonalInfoSettings = () => {
    const [errorMessage, setErrorMessage] = useState('');
    const dispatch = useDispatch();
    const userInfo = useSelector((state) => state.userData);
    const { data } = userInfo;

    const [formData, setFormData] = useState({
        U_FirstName: '',
        U_LastName: '',
        U_Email: '',
        U_Phone: '',
        address: '',
        city: '',
        state: '',
        zipCode: '',
        countryCode: '',
    });

    useEffect(() => {
        if (data) {
            setFormData({
                U_FirstName: data.U_FirstName || '',
                U_LastName: data.U_LastName || '',
                U_Email: data.U_Email || '',
                U_Phone: data.U_Phone || '',
                address: data.address || '',
                city: data.city || '',
                state: data.state || '',
                zipCode: data.zipCode || '',
                countryCode: data.countryCode || 'US',
            });
            setErrorMessage('');
        }
    }, [data]);

    const handleChange = (e) => {
        const value = e?.target ? e.target.value : e; 
        const name = e?.target ? e.target.name : 'countryCode'; 
    
        setFormData((prevState) => ({
            ...prevState,
            [name]: value,
        }));
        setErrorMessage('');
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        const updatedFields = {};
        if (!data) {
            console.error('User data is not available.');
            return; 
        }
        for (const key in formData) {
            const formValue = formData[key]?.trim();
            const userValue = data[key]?.trim() || data[`U_${key.charAt(0).toUpperCase() + key.slice(1)}`]?.trim();
    
            if (formValue !== userValue) {
                updatedFields[key] = formData[key];
            }
        }
        if (Object.keys(updatedFields).length > 0) {
            dispatch(updateUserData({"columns":updatedFields}));
            setErrorMessage('');
        } else {
            setErrorMessage('No changes detected. Please modify the fields before submitting.'); 
        }
    };



    return (
        <form onSubmit={handleSubmit}>
            <div className="settings-list-wrapper">
                <div className="single-settings">
                    <h5 className="setting-title">Personal Information</h5>
                    <div className="setting-content">
                        <div className="sng-content-repeater d-auto">
                            <div className="sng-content">
                                <label>First Name</label>
                                <input
                                    type="text"
                                    className="sett-form-input"
                                    name="U_FirstName"
                                    value={formData.U_FirstName}
                                    onChange={handleChange}
                                    placeholder="e.g. Jhon"
                                />
                            </div>
                            <div className="sng-content">
                                <label>Last Name</label>
                                <input
                                    type="text"
                                    className="sett-form-input"
                                    name="U_LastName"
                                    value={formData.U_LastName}
                                    onChange={handleChange}
                                    placeholder="e.g. Doe"
                                />
                            </div>
                        </div>
                        <div className="sng-content-repeater">
                            <div className="sng-content">
                                <label>Email</label>
                                <input
                                    type="email"
                                    className="sett-form-input"
                                    name="U_Email"
                                    value={formData.U_Email}
                                    onChange={handleChange}
                                    placeholder="e.g. jhondow007@mail.com"
                                />
                            </div>
                        </div>
                        <div className="sng-content-repeater">
                            <div className="sng-content">
                                <label>Phone</label>
                                <input
                                    className="sett-form-input"
                                    name="U_Phone"
                                    value={formData.U_Phone}
                                    onChange={handleChange}
                                    placeholder="+1 123 234 564"
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="single-settings">
                    <h5 className="setting-title">Billing Address</h5>
                    <div className="setting-content">
                        <div className="sng-content-repeater">
                            <div className="sng-content">
                                <label>Street address</label>
                                <input
                                    type="text"
                                    className="sett-form-input"
                                    name="address"
                                    value={formData.address}
                                    onChange={handleChange}
                                    placeholder="235 park street, NY"
                                />
                            </div>
                        </div>
                        <div className="sng-content-repeater">
                            <div className="sng-content">
                                <label>City</label>
                                <input
                                    type="text"
                                    className="sett-form-input"
                                    name="city"
                                    value={formData.city}
                                    onChange={handleChange}
                                    placeholder="e.g. NY"
                                />
                            </div>
                        </div>
                        <div className="sng-content-repeater d-auto">
                            <div className="sng-content">
                                <label>State</label>
                                <input
                                    type="text"
                                    className="sett-form-input"
                                    name="state"
                                    value={formData.state}
                                    onChange={handleChange}
                                    placeholder="e.g. State"
                                />
                            </div>
                            <div className="sng-content">
                                <label>Zip code</label>
                                <input
                                    type="text"
                                    className="sett-form-input"
                                    name="zipCode"
                                    value={formData.zipCode}
                                    onChange={handleChange}
                                    placeholder="e.g. 9000"
                                />
                            </div>
                        </div>
                        <div className="sng-content-repeater">
                            <div className="sng-content">
                                <label>Country</label>
                                {/* <CountrySelect
                                    containerClassName="form-group"
                                    inputClassName="sett-form-input"
                                    name="countryCode"
                                    onChange={handleChange}
                                    placeHolder="Select Country"
                                    defaultValue="BD"
                                    showFlag={false}
                                /> */}
                                <CountryDropdown 
                                    value={formData.countryCode} 
                                    name="countryCode"
                                    className="sett-form-input"
                                    valueType="short"
                                    onChange={handleChange}
                                    />
                                
                            </div>
                        </div>
                    </div>
                </div>
                <div className="button-wrapper form-error-wrapper">
                {errorMessage && <div className="error-message" style={{ color: 'red' }}>{errorMessage}</div>}
                    <button type="submit" className="btn submit-btn bg-primary">Update</button>
                </div>
            </div>
        </form>
    );
}

export default PersonalInfoSettings;
